import { Text, Tooltip } from '@radix-ui/themes';
import { ChevronDown, ChevronUp, StickyNote } from 'lucide-react';
import { Accordion } from 'radix-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const getActivityIcon = () => {
  return (
    <span
      className="score-pill-md m-1 mx-2 purple inline-flex! items-center justify-center"
      style={{ fontSize: '1.4rem' }}
    >
      <StickyNote size={16} />
    </span>
  );
};

export const ApplicationNotes = ({ notes }: { notes: { createdAt: Date; createdBy: string; text: string }[] }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string>();
  notes ??= [];
  return (
    <div className="activity-log">
      <Accordion.Root type="single" collapsible onValueChange={setSelected}>
        <Accordion.Item value="notes">
          <Accordion.Header>
            <Accordion.Trigger className="font-bold w-full">
              <span className="clickable flex justify-between">
                {t('candidate.notes.accordionLabel')}
                {selected === 'notes' ? <ChevronUp /> : <ChevronDown />}
              </span>
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="accordion-content">
            {notes.map((item, idx) => (
              <div key={`activity-${item.createdAt.valueOf() * idx}-${idx}`}>
                <div className="flex justify-between items-center">
                  <div className="flex items-center">
                    <span>{getActivityIcon()}</span>
                    <span style={{ whiteSpace: 'pre-wrap' }}>{item.text}</span>
                  </div>
                  <Tooltip content={<Text size="3">{new Date(item.createdAt).toLocaleString('sv-se')}</Text>}>
                    <span>{new Date(item.createdAt).toLocaleDateString('sv-se')}</span>
                  </Tooltip>
                </div>
                <div
                  className="flex flex-row-reverse"
                  style={{ fontSize: '67%', fontStyle: 'italic', marginTop: '-10px' }}
                >
                  - {item.createdBy}
                </div>
              </div>
            ))}
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </div>
  );
};
